import React from 'react';
import { titleize } from 'inflection';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

import { profileUrl, rankingUrl, defaultUserImageUrl } from 'buyside/util/urlHelper';
import { ActivityFeedRankFragment, Maybe } from 'interfaces/graphql-typings';

import styles from '../rankingStyles.scss';

const RankingProfileSection: React.FC<{
  canViewUserDetails: boolean;
  user: ActivityFeedRankFragment['user'];
  value: Maybe<number>;
  category: string;
}> = ({ category, value, user, canViewUserDetails }) => (
  <div data-testid="ranking-profile-section" className={styles.rankingLeftRow}>
    <div className={styles.profileImage}>
      <div className={styles.rankingDisplay}>
        <a href={rankingUrl(category)} className={styles.noHoverLink}>
          {typeof value === 'number' && <h2 className={styles.rankValue}>#{value + 1}</h2>}
          <div className={styles.rankingCategory}>
            {category === 'general' ? 'All-Time' : titleize(category)}
          </div>
        </a>
      </div>
      {canViewUserDetails && user?.id ? (
        <a href={profileUrl(user?.id)}>
          <ProfileImage source={user?.profileImageUrl} size="smaller" />
        </a>
      ) : (
        <div>
          <ProfileImage source={defaultUserImageUrl()} size="smaller" />
        </div>
      )}
    </div>
  </div>
);

export default RankingProfileSection;
